(function () {
  'use strict';

  function formatMoney(cents, format) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, format);
    }
    var value = (cents / 100).toFixed(2);
    return format ? format.replace(/\{\{\s*amount\s*\}\}/, value) : '$' + value;
  }

  function getVariantPriceCents(productData, variantId) {
    if (!productData || !productData.variants) return null;
    for (var i = 0; i < productData.variants.length; i++) {
      if (String(productData.variants[i].id) === String(variantId)) {
        return productData.variants[i].price;
      }
    }
    return null;
  }

  // The quantity input can be changed three ways: the visitor typing
  // (fires 'input'/'change' natively), the theme's own +/- stepper
  // buttons (assets/sections.js.liquid — sets .value via jQuery .val()
  // and triggers 'change'), or some other script on the page setting
  // .value directly without dispatching any event at all. Listening for
  // 'input'/'change' alone misses that third case. Instead of polling,
  // shadow the element's own 'value' accessor so any assignment — by us,
  // jQuery, or a third-party app — calls back synchronously, regardless
  // of whether it also dispatches an event.
  function watchInputValue(input, callback) {
    var descriptor = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value');
    if (!descriptor || !descriptor.configurable) return;

    Object.defineProperty(input, 'value', {
      configurable: true,
      enumerable: descriptor.enumerable,
      get: function () {
        return descriptor.get.call(this);
      },
      set: function (newValue) {
        descriptor.set.call(this, newValue);
        callback();
      },
    });
  }

  function initWidget(widget) {
    // The snippet renders its own <script> tag per widget (product page,
    // quick shop, sliders), so this file can execute several times on one
    // page. Without this guard each run would re-bind every listener.
    if (widget.hasAttribute('data-buy-more-save-initialized')) return;
    widget.setAttribute('data-buy-more-save-initialized', 'true');

    var productId = widget.getAttribute('data-product-id');
    // Resolve the form from the widget itself: the same product can appear
    // twice on a page (quick shop popup over its own page, slider + grid),
    // and getElementById would bind every widget to the first form.
    var form = widget.closest('[data-product-form]') || document.getElementById('product-form-' + productId);
    if (!form) return;

    var tiers;
    try {
      tiers = JSON.parse(widget.getAttribute('data-tiers'));
    } catch (e) {
      return;
    }

    var productData;
    try {
      productData = JSON.parse(form.getAttribute('data-product'));
    } catch (e) {
      return;
    }

    var moneyFormat = form.getAttribute('data-money-format');
    var variantSelect = form.querySelector('[data-variants]');
    var quantityInput = form.querySelector('#quantity');
    var addToCartButton = form.querySelector('.add_to_cart');
    var addToCartText = addToCartButton ? addToCartButton.querySelector('.text') : null;
    var defaultAddToCartLabel = addToCartButton
      ? addToCartButton.getAttribute('data-label') || (addToCartText ? addToCartText.textContent.trim() : '')
      : '';

    var tierButtons = widget.querySelectorAll('[data-buy-more-save-tier]');

    function currentVariantId() {
      return variantSelect ? variantSelect.value : (productData.variants[0] && productData.variants[0].id);
    }

    function renderTiers() {
      var priceCents = getVariantPriceCents(productData, currentVariantId());
      if (priceCents === null) return;

      Array.prototype.forEach.call(tierButtons, function (btn) {
        var qty = parseInt(btn.getAttribute('data-qty'), 10);
        var percent = parseFloat(btn.getAttribute('data-percent'));
        var unitCents = Math.round(priceCents * (1 - percent / 100));
        var totalCents = unitCents * qty;
        var baseTotalCents = priceCents * qty;

        var eachEl = btn.querySelector('[data-buy-more-save-each]');
        if (eachEl) eachEl.textContent = formatMoney(unitCents, moneyFormat);

        var wasEl = btn.querySelector('[data-buy-more-save-was]');
        var totalEl = btn.querySelector('[data-buy-more-save-total]');
        if (totalEl) totalEl.textContent = formatMoney(totalCents, moneyFormat);
        if (wasEl) {
          if (percent > 0) {
            wasEl.textContent = formatMoney(baseTotalCents, moneyFormat);
            wasEl.hidden = false;
          } else {
            wasEl.textContent = '';
            wasEl.hidden = true;
          }
        }
      });

      updateAddToCartLabel();
    }

    function bestTierForQty(qty) {
      var best = null;
      tiers.forEach(function (tier) {
        if (qty >= tier.qty && (!best || tier.qty > best.qty)) {
          best = tier;
        }
      });
      return best;
    }

    function setSelectedTier(qty) {
      Array.prototype.forEach.call(tierButtons, function (btn) {
        var btnQty = parseInt(btn.getAttribute('data-qty'), 10);
        btn.classList.toggle('is-selected', btnQty === qty);
      });
    }

    // The product price block (<div data-price-ui>) lives outside the form,
    // so walk up from the widget to the nearest ancestor that contains one.
    // Stop as soon as an ancestor holds more than one product form: past
    // that point a price block belongs to some other product (a grid of
    // cards), and rewriting it would change the wrong price.
    function findPriceUI() {
      var el = widget.parentElement;
      while (el) {
        if (el.querySelectorAll('[data-product-form]').length > 1) return null;
        var found = el.querySelector('[data-price-ui]');
        if (found) return found;
        el = el.parentElement;
      }
      return null;
    }

    var priceUI = findPriceUI();

    // Shows the tier's unit price in the main product price, with the
    // regular price struck through. Skipped while a sale discount
    // (data-sale-discount: 24h new-product promo or collection sale) is
    // already driving that price, so the two never overwrite each other.
    function updateProductPrice() {
      if (!priceUI || priceUI.hasAttribute('data-sale-discount')) return;

      var priceEl = priceUI.querySelector('.price');
      if (!priceEl) return;
      var compareEl = priceUI.querySelector('.compare-at-price');

      var qty = quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1;
      var tier = bestTierForQty(qty) || { percent: 0 };
      var priceCents = getVariantPriceCents(productData, currentVariantId());
      // Free variants keep the theme's own "Free" text.
      if (priceCents === null || priceCents === 0) return;

      if (tier.percent > 0) {
        // Remember what the theme rendered, so qty 1 / another variant can
        // restore it. Stored on the elements themselves: the theme replaces
        // them wholesale on variant change, which correctly drops the memo.
        if (priceEl.getAttribute('data-bms-original') === null) {
          priceEl.setAttribute('data-bms-original', priceEl.innerHTML);
          priceEl.setAttribute('data-bms-had-sale', priceEl.classList.contains('price--sale') ? '1' : '0');
          if (compareEl) compareEl.setAttribute('data-bms-original', compareEl.innerHTML);
        }
        var unitCents = Math.round(priceCents * (1 - tier.percent / 100));
        priceEl.innerHTML = '<span class="money">' + formatMoney(unitCents, moneyFormat) + '</span>';
        priceEl.classList.add('price--sale');
        if (compareEl) compareEl.innerHTML = '<span class="money">' + formatMoney(priceCents, moneyFormat) + '</span>';
      } else if (priceEl.getAttribute('data-bms-original') !== null) {
        priceEl.innerHTML = priceEl.getAttribute('data-bms-original');
        if (priceEl.getAttribute('data-bms-had-sale') !== '1') priceEl.classList.remove('price--sale');
        priceEl.removeAttribute('data-bms-original');
        priceEl.removeAttribute('data-bms-had-sale');
        if (compareEl && compareEl.getAttribute('data-bms-original') !== null) {
          compareEl.innerHTML = compareEl.getAttribute('data-bms-original');
          compareEl.removeAttribute('data-bms-original');
        }
      }
    }

    function updateAddToCartLabel() {
      updateProductPrice();
      if (!addToCartText || !quantityInput || !addToCartButton) return;
      var qty = parseInt(quantityInput.value, 10) || 1;
      var tier = bestTierForQty(qty) || { percent: 0 };
      var priceCents = getVariantPriceCents(productData, currentVariantId());
      if (priceCents === null) return;

      if (tier.percent > 0) {
        var unitCents = Math.round(priceCents * (1 - tier.percent / 100));
        var totalCents = unitCents * qty;
        addToCartText.textContent = defaultAddToCartLabel + ' — ' + formatMoney(totalCents, moneyFormat);
      } else {
        addToCartText.textContent = defaultAddToCartLabel;
      }
    }

    Array.prototype.forEach.call(tierButtons, function (btn) {
      btn.addEventListener('click', function () {
        var qty = parseInt(btn.getAttribute('data-qty'), 10);
        if (!quantityInput) return;

        // Setting .value triggers watchInputValue's hook below, which
        // re-syncs the tier selection and Add to Cart label for us.
        // Still dispatch 'change' so any other script on the page
        // (inventory checks, other apps) also sees the new quantity.
        quantityInput.value = qty;
        var evt;
        try {
          evt = new Event('change', { bubbles: true });
        } catch (e) {
          evt = document.createEvent('Event');
          evt.initEvent('change', true, true);
        }
        quantityInput.dispatchEvent(evt);
      });
    });

    if (quantityInput) {
      var handleQuantityChange = function () {
        var qty = parseInt(quantityInput.value, 10);
        if (!qty || qty < 1) {
          setSelectedTier(null);
          return;
        }
        var tier = bestTierForQty(qty);
        setSelectedTier(tier ? tier.qty : null);
        updateAddToCartLabel();
      };

      // 'input' covers real typing/native spinner arrows. The value-setter
      // hook (see watchInputValue above) covers every programmatic write —
      // the theme's own +/- stepper, jQuery .val() from any app, anything —
      // without needing to know which event, if any, it dispatches.
      // 'change' stays as a cheap fallback for browsers where redefining
      // the accessor isn't allowed.
      quantityInput.addEventListener('input', handleQuantityChange);
      quantityInput.addEventListener('change', handleQuantityChange);
      watchInputValue(quantityInput, handleQuantityChange);
      handleQuantityChange();
    }

    if (variantSelect) {
      // The theme dispatches its own non-bubbling change event on this
      // select (assets/sections.js.liquid) and, in the same handler,
      // resets the Add to Cart button label back to its default. Defer
      // our own update so it runs after that reset instead of being
      // overwritten by it.
      variantSelect.addEventListener('change', function () {
        window.setTimeout(renderTiers, 0);
      });
    }

    // The theme rebuilds the price block (replacing its children) on every
    // variant change; re-apply the tier price whenever that happens. Only
    // direct children are observed, so our own edits inside .price do not
    // retrigger this.
    if (priceUI && window.MutationObserver) {
      new MutationObserver(function () {
        updateProductPrice();
      }).observe(priceUI, { childList: true });
    }

    renderTiers();
  }

  function init() {
    var widgets = document.querySelectorAll('[data-buy-more-save]');
    Array.prototype.forEach.call(widgets, initWidget);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
